import { render, staticRenderFns } from "./ComposableProductPanel.vue?vue&type=template&id=803e6bd6&"
import script from "./ComposableProductPanel.vue?vue&type=script&lang=js&"
export * from "./ComposableProductPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports